import React, { Fragment } from "react";
/* import Home from '../Home/home'; */

import '../../Config/galeria-imagens.css';
import './galeri-carrocel.css';

/* import AM from '../../../images/HomePage/am1.jpeg'; */
/*bebidas*/
import Drink01 from '../../../images/Drink/drink-01.jpeg';
import Drink02 from '../../../images/Drink/drink-02.jpeg';
import Drink03 from '../../../images/Drink/drink3.jpeg';
import Drink04 from '../../../images/Drink/drink4.jpeg';
import Drink06 from '../../../images/Drink/drink6.jpeg';
import Cerva01 from '../../../images/Drink/cerva.jpeg';
import Cerva02 from '../../../images/Drink/cerva2.jpeg';
/*pratos*/
import Prato01 from '../../../images/Pratos/prato-01.jpeg';
import Prato02 from '../../../images/Pratos/prato-02.jpeg';
import Prato03 from '../../../images/Pratos/prato-03.jpeg';
import Prato04 from '../../../images/Pratos/prato-04.jpeg';

/*doces*/
import Doce01 from '../../../images/Pratos/doce-01.jpeg';
import Doce02 from '../../../images/Pratos/SB01.jpeg';

function Galery() {

    return (
        <Fragment>
            <div className="wrapper">
                <nav className="lil-nav">
                    <a href="#image-1">
                        <img className="lil-nav__img" src={Drink02} alt="Yosemite" />
                    </a>
                    <a href="#image-2">
                        <img className="lil-nav__img" src={Drink01} alt="Houses" />
                    </a>
                    <a href="#image-3">
                        <img className="lil-nav__img" src={Prato01} alt="Galaxies" />
                    </a>
                    <a href="#image-4">
                        <img className="lil-nav__img" src={Prato02} alt="Motel" />
                    </a>
                    <a href="#image-5">
                        <img className="lil-nav__img" src={Prato03} alt="Minimalist nightmare" />
                    </a>
                    <a href="#image-6">
                        <img className="lil-nav__img" src={Prato04} alt="Hoops" />
                    </a>
                    <a href="#image-7">
                        <img className="lil-nav__img" src={Drink03} alt="drink" />
                    </a>
                    <a href="#image-8">
                        <img className="lil-nav__img" src={Drink04} alt="drink" />
                    </a>
                    <a href="#image-9">
                        <img className="lil-nav__img" src={Cerva01} alt="drink" />
                    </a>
                    <a href="#image-10">
                        <img className="lil-nav__img" src={Cerva02} alt="drink" />
                    </a>
                    <a href="#image-11">
                        <img className="lil-nav__img" src={Doce01} alt="drink" />
                    </a>
                    <a href="#image-12">
                        <img className="lil-nav__img" src={Doce02} alt="drink" />
                    </a>
                    <a href="#image-13">
                        <img className="lil-nav__img" src={Drink06} alt="drink" />
                    </a>
                </nav>

                <div className="gallery">
                    <img className="gallery__img images" id="image-1" src={Drink02} alt="Yosemite" />
                    <img className="gallery__img images" id="image-2" src={Drink01} alt="Houses" />
                    <img className="gallery__img images" id="image-3" src={Prato01} alt="Galaxies" />
                    <img className="gallery__img images" id="image-4" src={Prato02} alt="Motel" />
                    <img className="gallery__img images" id="image-5" src={Prato03} alt="Minimalist nightmare" />
                    <img className="gallery__img images" id="image-6" src={Prato04} alt="Hoops" />
                    <img className="gallery__img images" id="image-7" src={Drink03} alt="Gentleman" />
                    <img className="gallery__img images" id="image-8" src={Drink04} alt="Stuff" />
                    <img className="gallery__img images" id="image-9" src={Cerva01} alt="Stuff" />
                    <img className="gallery__img images" id="image-10" src={Cerva02} alt="Stuff" />
                    <img className="gallery__img images" id="image-11" src={Doce01} alt="Stuff" />
                    <img className="gallery__img images" id="image-12" src={Doce02} alt="Stuff" />
                    <img className="gallery__img images" id="image-13" src={Drink06} alt="Stuff" />
                </div>
            </div>
        </Fragment>
    )
}

export default Galery;